import Slogun from '../../components/Slogun';
import Footer from '../../components/Footer';

function Rnd(props) {
  const patentImgList = [
    {
      imgUrl: '/assets/images/rnd/img_patent_01.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_02.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_03.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_04.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_05.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_06.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_07.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_08.jpg',
    },
    {
      imgUrl: '/assets/images/rnd/img_patent_09.jpg',
    },
  ];

  return (
    <>
      <div className='w-full h-full'>
        <div
          id='visual'
          className='flex items-center justify-center flex-col bg-[url("/public/assets/images/rnd/bg_visual.jpg")] bg-cover bg-center h-[282px] md:h-[554px]'
        >
          <p
            className='text-center text-3xl md:text-[3.45rem] font-bold text-white md:leading-tight leading-5'
            data-aos='fade-up'
          >
            NOAH PRODUCT R&D
          </p>
          <p
            className='mt-5 text-base font-medium text-center text-white md:mt-7 md:text-2xl'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            건강한 미래를 위해 꾸준한 관심과
            <br className='md:hidden' /> 상품연구를 기울이고 있습니다.
          </p>
        </div>
        <div
          className='text-center py-[4.4rem] lg:py-32'
          data-aos='fade-up'
          data-aos-duration='1000'
        >
          <p className='text-sm leading-[1.4rem] font-medium lg:text-xl lg:leading-[1.5]'>
            신제품 개발과 기존 제품의 품질 개선에 <br className='lg:hidden' />
            중심적 역할을 하고 있습니다.
            <br />
            건강한 미래를 위해 항상 진심을 다하여 <br className='lg:hidden' />
            기술에 대해 꾸준한 관심과 연구를 기울이고 있습니다
          </p>
          <p className='text-2xl font-bold leading-[1.25] mt-5 lg:text-[2.8rem] lg:mt-9'>
            New Zealand Radiate <br className='lg:hidden' />
            Pine Bark Extract
          </p>
          <p className='mt-[1.9rem] lg:mt-10 text-lg font-bold text-center before:mb-3 before:lg:mb-5 before:content-[""] before:inline-block before:w-[1px] before:h-[60px] before:bg-black'>
            <span className='block'>Enzogenol</span>
          </p>
        </div>

        <div className='justify-center px-5 pb-12 md:flex md:flex-col md:items-center'>
          <div className='justify-center md:flex md:items-center lg:max-w-[1280px]'>
            <div className='md:w-1/2'>
              <img
                className='lg:hidden'
                src={`${process.env.PUBLIC_URL}/assets/images/rnd/m_img_rnd_01.jpg`}
                alt=''
              />
              <img
                className='hidden lg:block'
                src={`${process.env.PUBLIC_URL}/assets/images/rnd/img_rnd_01.jpg`}
                alt=''
              />
            </div>
            <div className='mt-9 md:w-1/2 md:p-5 md:mt-0 lg:px-10'>
              <p className='text-xs font-semibold lg:text-xl'>엔조제놀이란?</p>
              <p className='mt-4 text-2xl font-bold lg:text-[2.5rem] lg:mt-5 lg:leading-tight'>
                엔조제놀은 프로안토시아니딘,
              </p>
              <p className='mt-2 text-sm font-medium leading-6 break-keep lg:text-lg lg:mt-5 lg:leading-[2.2rem]'>
                바이오플라보노이드, 유기산으로 구성된 강력한 천연 항산화/ 항염증
                천연물질입니다. 뉴질랜드산 파이너스 라디아타(pinus
                padiata)소나무 껍질에서 국제 특허 기술인 순수 물 추출(pure water
                extraction)공법으로 추출한 100%천연 액기스입니다.
                파이나너스라디아 소나무 조림지는 최적의 성장 환경을 갖추고 있는
                청정 뉴질랜드에 위치해 있습니다. 최적의 조림지를 충분히
                확보함으로써 고품질 원료를 지속 생산할 수 있습니다. 뉴질랜드
                소나무 추출물은 균등한 품질의 원재료를 확보하도록 했습니다.
                유적학적으로 동일한 25~30년생 소나무만 골라 밑동뿌터 3분의
                1지점까지만 채취한 소나무 껍질을 사용함으로써, 균등한 품질의
                원재료를 확보합니다.같은 연령의 소나무와 동질의 소나무 껍질을
                사용함에 따라 원재료의 일관성을 유지하도록 합니다. 이로 인해
                소나무 껍질 추출물이 일정한 성분을 유지하게 됩니다.{' '}
              </p>
            </div>
          </div>
          <div className='justify-center mt-24 md:flex md:items-center lg:max-w-[1280px]'>
            <div className='md:w-1/2 md:order-2'>
              <img
                className='lg:hidden'
                src={`${process.env.PUBLIC_URL}/assets/images/rnd/m_img_rnd_02.jpg`}
                alt=''
              />
              <img
                className='hidden lg:block'
                src={`${process.env.PUBLIC_URL}/assets/images/rnd/img_rnd_02.jpg`}
                alt=''
              />
            </div>
            <div className='mt-9 md:w-1/2 md:p-5 md:mt-0 lg:px-10 md:order-1'>
              <p className='text-xs font-semibold lg:text-xl'>기술의 장점</p>
              <p className='mt-4 text-2xl font-bold lg:text-[2.5rem] lg:mt-5 lg:leading-tight'>
                순수 물 추출 공법
              </p>
              <p className='mt-2 text-sm font-medium leading-6 break-keep lg:text-lg lg:mt-5 lg:leading-[2.2rem]'>
                <span className='md:block'>
                  엔조제놀은 ‘순수 물 추출 공법’으로 뽑아냅니다.
                </span>{' '}
                ENZO Nutraceuticals Limmited의 연구팀과 엔지니어팀이 공동
                연구하여 개발해 낸 이 추출법은 다른 화학약품을 일절 사용하지
                않고 순수 물만을 사용하는 국제적으로 특허 받은 공법 입니다.
              </p>
            </div>
          </div>
        </div>
        <div className='px-5 py-24 lg:flex lg:justify-center lg:flex-col lg:items-center lg:py-28 '>
          <div className='lg:order-2 lg:mt-16'>
            <img
              className='hidden lg:block'
              src={`${process.env.PUBLIC_URL}/assets/images/rnd/img_pure_water.jpg`}
              alt=''
            />
            <img
              className='lg:hidden'
              src={`${process.env.PUBLIC_URL}/assets/images/rnd/m_img_pure_water.jpg`}
              alt=''
            />
          </div>
          <div className='mt-9 md:p-5 md:mt-0 lg:max-w-[1320px] lg:order-1'>
            <p className='text-xs font-semibold lg:text-xl'>
              엔조제놀 생산 과정 특징
            </p>
            <p className='mt-4 text-2xl font-bold lg:text-[2.5rem] lg:mt-5 lg:leading-tight'>
              Pure Water Process
            </p>
            <p className='mt-2 text-sm font-medium leading-6 break-keep lg:text-lg lg:mt-5 lg:leading-[2.2rem]'>
              오직 깨끗이 정제된 비온수화만을 사용하여 추출하는 과정. 추출
              과정에 어떠한 화학물질도 사용하지 않음으로써 화학물이 추출물에
              잔존할 수 있는 가능성을 제거했습니다. [Full pollyphenol compound
              spectrum]소나무 껍질에서 추출한 천연 화합물이 건간에 유익한 모든
              폴리페놀 화합물을 포함핟도록 합니다. [Protexting maximal activity]
              추출 과정 에서 자연 화합물이 손상되지 않도록 최대한 보호함으로써
              최대 항산화 효과를 내도록 유념 합니다 [Ecologically sound
              technology]친환경 생산라인으로 산업 쓰레기를 배출하지 않습니다.
            </p>
          </div>
        </div>
        <div className='flex items-center text-center flex-col justify-center w-full h-auto pt-16 pb-24  md:pt-40 md:pb-56 bg-gradient-to-b from-[#DBE9FA] to-[#EAF5FE]'>
          <p
            className='text-2xl font-bold leading-9 lg:text-[2.8rem] lg:leading-tight'
            data-aos='fade-up'
          >
            노아는 안전하고 믿을 수 있는
            <br />
            제조사와 함께 합니다.
          </p>
          <p
            className='mt-5 text-base font-medium leading-6 lg:text-xl lg:mt-10'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            삶을 실현하는 생명과학기업
            <br className='md:hidden' />
            에스에스 바이오팜과 함께 합니다.
          </p>
          <div
            className='px-5 mt-10 lg:mt-24 '
            data-aos='fade-up'
            data-aos-duration='2000'
          >
            <ul className='flex justify-center flex-wrap items-stretch lg:max-w-[1720px] lg:flex-wrap'>
              {patentImgList.map((item, idx) => (
                <li className='m-[5px] lg:m-5 basis-[calc(33.3%-20px)] lg:w-auto lg:basis-auto'>
                  <img src={`${process.env.PUBLIC_URL}${item.imgUrl}`} alt='' />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Slogun />
        <Footer />
      </div>
    </>
  );
}

export default Rnd;
